/**
 * Locale (es-ES) — copy específica del listado moderno de Tareas.
 * Solo agregamos llaves nuevas; reutilizamos las existentes en
 * `tasks/locales/es-ES.js` (status, importance, type) para no duplicar
 * copy. Las globales `global.text.from / to / orderBy` ya están
 * declaradas por Solicitudes Modern.
 */
export default {
  'tasksModern.title': 'Tareas',
  'tasksModern.summary':
    'Gestiona tus tareas pendientes, comprométete con tu día y sigue tus aprobaciones.',
  'tasksModern.refresh': 'Actualizar',
  'tasksModern.newTask': 'Adicionar tarea',

  'tasksModern.row.moreActions': 'Más acciones',
  'tasksModern.row.hasNotes': 'Esta tarea tiene una nota',
  'tasksModern.row.created': 'Creada',
  'tasksModern.row.planned': 'Planeada',
  'tasksModern.row.overdue': 'Vence',
  'tasksModern.row.reminder': 'Recordatorio',
  'tasksModern.row.relatedPeople':
    '{count, plural, one {# persona relacionada} other {# personas relacionadas}}',

  'tasksModern.date.today': 'Hoy',
  'tasksModern.date.tomorrow': 'Mañana',
  'tasksModern.date.yesterday': 'Ayer',

  'tasksModern.filters.toggle': 'Filtros',
  'tasksModern.filters.clearAll': 'Limpiar todos',

  'tasksModern.toolbar.order.desc': 'Reciente',
  'tasksModern.toolbar.order.asc': 'Antigua',

  'tasksModern.empty.noTasks.title': 'No tienes tareas aquí todavía',
  'tasksModern.empty.noTasks.titleFor': 'No tienes tareas en "{name}" todavía',
  'tasksModern.empty.noTasks.description':
    'Cuando se asignen nuevas tareas o las agregues a esta lista, aparecerán acá.',

  'tasksModern.empty.noResults.title': 'No encontramos tareas',
  'tasksModern.empty.noResults.titleFor': 'Sin coincidencias en "{name}"',
  'tasksModern.empty.noResults.description':
    'Ajusta los filtros o el rango de fechas para ver más resultados.',

  // ────────── "New task" drawer (MS To Do style) ──────────
  'tasksModern.newTask.heroTitle': 'Nueva tarea',
  'tasksModern.newTask.heroSummary': 'Captúrala antes de que se te olvide.',
  'tasksModern.newTask.titlePlaceholder': '¿Qué necesitas hacer?',
  'tasksModern.newTask.notesPlaceholder': 'Añade una nota o detalle…',
  'tasksModern.newTask.dateHint': 'Selecciona fecha',
  'tasksModern.newTask.cta': 'Crear tarea',
  'tasksModern.newTask.quickLabel': 'Plan',
  'tasksModern.newTask.today': 'Hoy',
  'tasksModern.newTask.tomorrow': 'Mañana',
  'tasksModern.newTask.nextWeek': 'En 7 días',

  // ────────── Detail drawer (autosave) ──────────
  'tasksModern.detail.heroTitle': 'Detalle de la tarea',
  'tasksModern.detail.editTitle': 'Click para editar el título',
  'tasksModern.detail.changeStatus': 'Cambiar estado',
  'tasksModern.detail.requestedBy': 'Solicitada por',
  'tasksModern.detail.createdAt': 'Creada',
  'tasksModern.detail.relatedUsers': 'Personas relacionadas',
  'tasksModern.detail.actions': 'Acciones',
  'tasksModern.detail.savedHint': 'Los cambios se guardan automáticamente',
  'tasksModern.detail.notesPlaceholder': 'Añade contexto, links o checklist…',

  // ────────── MS To Do-style date picker ──────────
  'tasksModern.smartDate.placeholder': 'Selecciona fecha',
  'tasksModern.smartDate.today': 'Hoy',
  'tasksModern.smartDate.tomorrow': 'Mañana',
  'tasksModern.smartDate.nextWeek': 'Próxima semana',
  'tasksModern.smartDate.pick': 'Elegir fecha',
  'tasksModern.smartDate.clear': 'Limpiar',

  // ────────── Date validation ──────────
  'tasksModern.dateValidation.future':
    'La fecha "{field}" debe ser mayor a la fecha y hora actual.',
};
